















import { Vue, Component, Model, Prop, Watch } from 'vue-property-decorator';

import { getMonthFromDate, getCurrentMonth } from '@/utils/date';

import { ISOCalendarDate, ISOMonth, Weekday } from '@/utils/date/types';

import { formatMonthToHumanText } from '@/utils/date'

const initDefaultMonth = (date: ISOCalendarDate | '', month?: ISOMonth) => {
    if (month) {
        return month;
    }

    if (date) {
        return getMonthFromDate(date);
    }

    return getCurrentMonth();
}

@Component({
    name: 'BaseDatepicker',
})
export default class BaseDatepicker extends Vue {
    @Model('update:date') readonly date!: ISOCalendarDate
    @Prop() readonly min!: string
    @Prop() readonly max!: string
    @Prop() readonly initialMonth!: ISOMonth
    @Prop() readonly highlight!: ISOCalendarDate

    visibleMonth = initDefaultMonth(this.date, this.initialMonth)

    @Watch('initialMonth')
    resetVisibleMonth(month: ISOMonth) {
        // if date is selected, don't reset month
        if (this.date) {
            return;
        }

        this.visibleMonth = month;
    }

    get dateModel() {
        return this.date
    }

    set dateModel(date) {
        this.$emit('update:date', date)
    }

    get firstDay() {
        return Weekday.Monday;
    }

    formatDateToMonth(date: ISOCalendarDate) {
        return formatMonthToHumanText(date);
    }
}
